import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { selectActualFeatureFlags, selectActualLicenses } from 'containers/App/selectors'
import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'
import { selectCompanyFilter } from 'containers/PartnerOptions/selectors'

import { selectHasIncidentWidgetAccess, selectIncidentsWidgetsVisibility } from '../selectors'

import { selectEndUserFilter, SET_END_USER_FILTER, urgentUnclassifiedIncidentsRedux } from './redux'

const TEN_MINUTES = 10 * 60 * 1000

const pollingEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(
      urgentUnclassifiedIncidentsRedux.INITIATE,
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      SET_END_USER_FILTER
    )
    .filter((action) =>
      action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS
        ? matchURL(URL_CONST.dashboard.home)
        : true
    )
    .switchMap(() => {
      const state = store.getState()
      const hasUserPermissions = selectIncidentsWidgetsVisibility(state)
      const hasCompanyPermissions = selectHasIncidentWidgetAccess(state)
      const licenses = selectActualLicenses(state)
      const ff = selectActualFeatureFlags(state)
      const featureFlagsEnabled = ff.ENABLE_AUTO_THEMIS || licenses.incident_management_service
      const shouldInitPolling = hasUserPermissions && hasCompanyPermissions && !featureFlagsEnabled
      if (!shouldInitPolling) {
        return Observable.empty()
      }
      return Observable.interval(TEN_MINUTES)
        .startWith(0)
        .switchMap(() => {
          const companyId = selectCompanyFilter(state)?.value
          const endUser = selectEndUserFilter(state)

          return api.dashboard
            .getUnclassifiedIncidents(companyId, endUser)
            .switchMap((response) =>
              Observable.of(urgentUnclassifiedIncidentsRedux.onSuccess(response?.response))
            )
            .catch((error) =>
              Observable.of(epicsErrorHandler(urgentUnclassifiedIncidentsRedux.onError, error))
            )
        })
        .takeUntil(action$.ofType(urgentUnclassifiedIncidentsRedux.CANCEL))
    })

export default combineEpics(pollingEpic)
